import React, { PureComponent } from 'react'
import {
  Button,
  Form,
  Input,
  Icon,
  Upload,
  Select,
  Row,
  Col,
  Modal,
  notification,
} from 'antd'
import { FormComponentProps, ValidationRule } from 'antd/lib/form'
import styles from './index.scss'
import { UploadChangeParam } from 'antd/lib/upload'
import { UploadFile } from 'antd/lib/upload/interface'
import { token as fetchToken } from 'services/api/upload'
import { feedback as feedbackApi } from 'services/api'
import qnUpload from 'util/qnUpload'

interface Props extends FormComponentProps {
  category: any[]
  callback: React.EventHandler<any>
}
interface State {
  previewImage: string
  previewVisible: boolean
  fileList: UploadFile[]
  selected: number | string
  canUpload: boolean
}

type FieldVal = {
  content: string
  id: number
  screenshot: any[]
}

class FeedbackForm extends PureComponent<Props, State> {
  private qnDomain: string = 'http://xy-v.jingzhuan.cn/'
  private rules: ValidationRule[] = [
    {
      required: true,
      message: '请输入反馈详情',
    },
  ]

  constructor(props) {
    super(props)
    this.state = {
      previewImage: '',
      previewVisible: false,
      fileList: [],
      selected: 0,
      canUpload: true,
    }
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    const { category } = nextProps
    const selected = category.length ? category[0].feedback_category_id : ''
    return {
      ...prevState,
      selected,
    }
  }

  componentDidUpdate() {
    const { getFieldValue } = this.props.form
    const values = getFieldValue('screenshot') || []
    this.setState({
      canUpload: !(values.length > 3),
    })
  }

  validate = () =>
    new Promise((resolve, reject) => {
      const {
        form: { validateFields },
      } = this.props
      validateFields((err, values) => {
        if (err) {
          reject(err)
        }
        resolve(values)
      })
    })

  async postFeedback({ content, id, screenshot }: FieldVal) {
    const {
      form: { resetFields },
      callback,
    } = this.props
    try {
      const imgs = screenshot ? screenshot.join(',') : undefined
      const { data } = await feedbackApi.postFeedback(id, content, imgs)
      notification.success({
        description: '反馈成功',
        message: data || '反馈成功',
      })
      resetFields()
      callback('finish')
    } catch (err) {
      notification.error({
        message: '发生错误',
        description: err.stack || '发生错误',
      })
      console.error(err)
    }
  }

  handleUploadChange = ({ fileList }: UploadChangeParam) =>
    this.setState({ fileList })

  handleTypeChange = data => {
    console.log(data)
  }

  handlePreview = file => {
    this.setState({
      previewImage: file.url || file.thumbUrl,
      previewVisible: true,
    })
  }

  handleCancel = () => this.setState({ previewVisible: false })

  handleUpload = e => fetchToken().then(({ token }) => qnUpload(token)(e))

  getValueFromEvent = e => {
    if (Array.isArray(e)) {
      return e
    }
    return e && e.fileList
  }

  onSubmit = async e => {
    e.preventDefault()
    try {
      const val: FieldVal = (await this.validate()) as FieldVal
      if (val.screenshot) {
        val.screenshot = val.screenshot.map(
          ({ response }) => `${this.qnDomain + response.key}`,
        )
      }
      this.postFeedback(val)
    } catch (err) {
      console.error(err)
    }
  }

  render() {
    const {
      form: { getFieldDecorator, getFieldValue },
      category,
    } = this.props
    const { selected, previewImage, previewVisible } = this.state

    const uploadButton = (
      <div>
        <Icon type="plus" />
        <div className="ant-upload-text">点击上传</div>
      </div>
    )
    return (
      <div className={styles.feedbackForm}>
        <Form onSubmit={this.onSubmit}>
          <Form.Item
            label="反馈类型"
            labelCol={{ span: 2 }}
            wrapperCol={{ span: 18 }}
            className={styles.feedbackFormItem}
          >
            {getFieldDecorator('id', {
              initialValue: selected,
            })(
              <Select style={{ width: '32%' }} onChange={this.handleTypeChange}>
                {category &&
                  category.map(({ feedback_category_id: id, name }) => (
                    <Select.Option key={id} value={id}>
                      {name}
                    </Select.Option>
                  ))}
              </Select>,
            )}
          </Form.Item>
          <Form.Item
            label="反馈详情"
            labelCol={{ span: 2 }}
            wrapperCol={{ span: 18 }}
            className={styles.feedbackFormItem}
          >
            {getFieldDecorator('content', {
              rules: this.rules,
            })(
              <Input.TextArea
                placeholder="您遇到的问题是"
                autosize={{ minRows: 6 }}
              />,
            )}
          </Form.Item>
          <Form.Item
            label="提供截图"
            labelCol={{ span: 2 }}
            wrapperCol={{ span: 18 }}
            className={styles.feedbackFormItem}
          >
            {getFieldDecorator('screenshot', {
              valuePropName: 'fileList',
              getValueFromEvent: this.getValueFromEvent,
            })(
              <Upload
                accept="image/*"
                action="http://xy-v.jingzhuan.cn"
                listType="picture-card"
                className="avatar-uploader"
                onPreview={this.handlePreview}
                customRequest={this.handleUpload}
              >
                {this.state.canUpload && uploadButton}
              </Upload>,
            )}
            <Modal
              visible={previewVisible}
              footer={null}
              onCancel={this.handleCancel}
            >
              <img alt="example" style={{ width: '100%' }} src={previewImage} />
            </Modal>
          </Form.Item>
          <Form.Item>
            <Row>
              <Col offset={2}>
                <Button type="primary" htmlType="submit">
                  提交
                </Button>
              </Col>
            </Row>
          </Form.Item>
        </Form>
      </div>
    )
  }
}

export default Form.create()(FeedbackForm) as any
